import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getSectionVisibleActionType } from 'src/redux/visibilityTracking';
import { onExpandProductDescriptionToggle } from '../modules/actions';
import {
  PRODUCT_DESCRIPTION_VISIBILITY_NAME,
  ProductDescriptionImpression,
  ProductDescriptionToggleExpand,
} from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [getSectionVisibleActionType(PRODUCT_DESCRIPTION_VISIBILITY_NAME)]: () => {
    sendGAEvent<ProductDescriptionImpression>({
      event: 'custom_event',
      event_category: 'Product long description',
      event_action: 'Impression',
      event_label: 'not set',
    });
  },
  [onExpandProductDescriptionToggle.type]: (_, __, action) => {
    const { payload: isOpen } = action as ReturnType<typeof onExpandProductDescriptionToggle>;

    if (isOpen) {
      sendGAEvent<ProductDescriptionToggleExpand>({
        event: 'custom_event',
        event_category: 'Product long description',
        event_action: 'Show more',
        event_label: 'not set',
      });
    }
  },
};
